const state = {
  aliasBlocks: [],
  userBlocks: [],
  userIsBlockedGlobal: {},
  aliasIsBlockedGlobal: {},
};

const getters = {
  aliasBlocks: (state) => state.aliasBlocks,
  userBlocks: (state) => state.userBlocks,
  userIsBlockedGlobal: (state) => state.userIsBlockedGlobal,
  aliasIsBlockedGlobal: (state) => state.aliasIsBlockedGlobal,
};

const mutations = {
  setUserIsBlockedGlobal: (state, payload) => state.userIsBlockedGlobal = payload,
  setAliasIsBlockedGlobal: (state, payload) => state.aliasIsBlockedGlobal = payload,
  setUserBlocks: (state, payload) => state.userBlocks.push(payload),
  setAliasBlocks: (state, payload) => state.aliasBlocks.push(payload),
};

const actions = {
  setBlocks({ commit }, payload) {
    const globalBlocks = payload.filter((el) => !el.customerId);

    for (const block of globalBlocks) {
      if (block.aliasId !== 0) commit("setAliasIsBlockedGlobal", { duration: block.end });
      if (block.userId !== 0) commit("setUserIsBlockedGlobal", { duration: block.end });
    }

    const customerBlocks = payload.filter((el) => el.customerId > 0);

    for (const block of customerBlocks) {
      if (block.userId !== 0) commit("setUserBlocks", { customer: block.customerName, duration: block.end });
      if (block.aliasId !== 0) commit("setAliasBlocks", { customer: block.customerName, duration: block.end });
    }
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
